<div class="flex f-fd--column">
  <howden-page-title></howden-page-title>

  <mat-card appearance="outlined" class="margin-top-15">
    <mat-card-header class="flex f-jc--center">
      <mat-card-title i18n="@@app.sane-projects.calculator.label">
        Resumen Primas
      </mat-card-title>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
      <table class="tabla-seguros">
        <thead>
          <tr>
            <th></th>
            @for (industry of activeIndustries; track industry) {
              <th>
                {{ industryLabels[industry] }}
                <small>(€/mes)</small>
              </th>
            }
            <th>
              TOTAL {{ periodLabel }}
              <small>(€)</small>
            </th>
            @if (paymentsPerYear !== 1) {
              <th>
                TOTAL ANUAL
                <small>(€)</small>
              </th>
            }
          </tr>
        </thead>

        <tbody>
          @for (insurer of insurersList; track insurer.key) {
            @if (getRowPeriod(insurer.key) > 0) {
              <tr>
                <td>{{ insurer.label }}</td>

                @for (industry of activeIndustries; track industry) {
                  <td>
                    <howden-label-value
                      [value]="(getCellMonthly(insurer.key, industry) | number:'1.2-2') ?? '0'">
                    </howden-label-value>
                  </td>
                }

                <td>{{ getRowPeriod(insurer.key) | number:'1.2-2' }}</td>
                @if (paymentsPerYear !== 1) {
                  <td>{{ getRowAnnual(insurer.key) | number:'1.2-2' }}</td>
                }
              </tr>
            }
          }

          <tr>
            <td>Total</td>

            @for (industry of activeIndustries; track industry) {
              <td>{{ (getIndustryPeriod(industry) / monthsPerPeriod) | number:'1.2-2' }}</td>
            }

            <td>{{ totalPeriod | number:'1.2-2' }}</td>
            @if (paymentsPerYear !== 1) {
              <td>{{ totalAnnual | number:'1.2-2' }}</td>
            }
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <div class="flex margin-top-25">
    <div class="flex f-basis--6 f-jc--center f-ai--center">
      <button mat-raised-button color="cancel" (click)="onCancel()">Volver</button>
    </div>
    <div class="flex f-basis--6 f-jc--center f-ai--center">
      <button mat-raised-button color="success" (click)="onSubmit()">Generar Programa de Previsión Social Individual</button>
    </div>
  </div>
</div>
